import { defineStyleConfig } from '@chakra-ui/styled-system';
import { ThemeColorVariable, ThemeFontSizeVariable, ThemeFontVariable, ThemeSpaceVariable, } from '../../theme-types';
export const paginatorConfig = defineStyleConfig({
    baseStyle: {
        width: '100%',
        fontFamily: ThemeFontVariable.Body,
        color: ThemeColorVariable.OnBackground,
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        padding: ThemeSpaceVariable.Small,
        gap: ThemeSpaceVariable.Medium,
        div: {
            button: {
                fontSize: ThemeFontSizeVariable.Large,
            },
        },
    },
});
//# sourceMappingURL=paginator-theme.js.map